import { isNumber } from "lodash";

export const renderRightText = (text, className = "acc-s-cell-int") => (
  <div className={className}>
    {isNumber(text) ? text.toLocaleString() : text}
  </div>
);
